import { jsx, jsxs } from "react/jsx-runtime";
import { Link, Text } from "pcln-design-system";
import { useContext } from "react";
import { ChatbotDataContext } from "../../context/ChatbotDataContext.js";
import { TravelBotLogoImage } from "../../TravelBotLogoImage.js";
import { ChatMessage } from "../CustomChatMessage/index.js";
import MessageFooter from "../MessageFooter/MessageFooter.js";
import PennyChatBubble from "../PennyChatBubble/index.js";
function DisplayFeedbackMarker({ msg, message, surveyLink, anchorMessage }) {
    const { setiValues } = useContext(ChatbotDataContext);
    const content = /*#__PURE__*/ jsxs(Text, {
        children: [
            message,
            /*#__PURE__*/ jsxs(Link, {
                href: surveyLink,
                target: "_blank",
                children: [
                    "\xa0",
                    anchorMessage
                ]
            })
        ]
    });
    return setiValues?.shouldEnablePortalUpdates ? /*#__PURE__*/ jsx(PennyChatBubble, {
        message: msg,
        children: content
    }) : /*#__PURE__*/ jsx(ChatMessage, {
        ml: "",
        mb: "8px",
        variation: 'initial',
        Icon: TravelBotLogoImage,
        message: content,
        footer: /*#__PURE__*/ jsx(MessageFooter, {})
    });
}
export { DisplayFeedbackMarker as default };
